const { useEffect } = wp.element
import { useSelector, useDispatch } from 'react-redux'
import * as actions from 'data/redux/actions'

export const useContent = (url) => {

  const dispatch = useDispatch()

  const contents = useSelector(state => state.ui.contents)

  useEffect(() => {

    if (contents[url]) { return; }

    refresh()

  }, [url])

  const refresh = () => {

    if (!url) return
    
    dispatch(actions.loadWPContent(url))
  }

  return {
    content: contents[url]?.content,
    blocks: contents[url]?.blocks,
    description: contents[url]?.description,
    image: contents[url]?.image,
    title: contents[url]?.title,
    refresh
  }
}
